export const PatientDashboardTypeEnum = {
    RECENT_RECORDING: 1,
    INACTIVE: 2,
    ALL: 3,
    SEARCH: 4
};
